import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Pageview tracking for a single-page app.
 *
 * The tag only ever sees one document load, so every route change has to be
 * reported by hand. Rendered *after* `<Routes>` in App.tsx, which is the
 * closest this app can get to reporting a settled page: routes whose title is
 * already known set it in an effect that runs first. Routes that only learn
 * their title from data — the map, a shared bar — are still reported the
 * moment they are entered rather than held back, because a visitor who leaves
 * before their data lands is a visitor who must still be counted.
 */
export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // "/" exists only to bounce the visitor to a city, so it would otherwise
    // put a phantom hit in front of every session's real first page.
    if (location.pathname === '/') return;

    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};
